import { useEffect, useState } from "react";

/* Automatically focus on a given input element as fed into the returned function */
export const useInputAutoFocus = () => {
    const [inputElement, setInputElement] = useState<HTMLInputElement>();
    useEffect(() => {
        inputElement?.focus();
    }, [inputElement]);
    return (ref: HTMLInputElement) => setInputElement(ref);
};
